import { styled, Typography } from '@mui/material';
import HouseStock from '@assets/images/HouseStock.jpg';

export const Styles = {
  PageContainer: styled('div')(({ theme }) => ({
    display: 'flex',
    height: '100vh',
    overflow: 'hidden',
    [theme.breakpoints.down('lg')]: {
      flexDirection: 'column',
      height: 'auto',
      minHeight: '100vh'
    }
  })),

  LeftPanel: styled('div')(({ theme }) => ({
    flex: 1,
    backgroundImage: `url(${HouseStock})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    padding: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      minHeight: '300px',
      padding: theme.spacing(2)
    }
  })),

  ImageSection: styled('div')(({ theme }) => ({
    flex: 1,
    backgroundImage: 'url(https://source.unsplash.com/random?real-estate)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  })),
  FormSection: styled('div')(({ theme }) => ({
    width: '500px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.background.paper,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: theme.spacing(2)
    }
  })),
  FormContainer: styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    maxWidth: '400px',
    padding: '0 20px'
  }),
  LogoContainer: styled('div')({
    marginBottom: '30px'
  }),
  Form: styled('form')({
    width: '100%',
    marginTop: '20px'
  }),

  TextField: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#105330'
      },
      '&:hover fieldset': {
        borderColor: '#2FB674'
      }
    }
  },
  OptionsContainer: styled('div')({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '10px',
    marginBottom: '20px'
  }),
  Checkbox: {
    color: '#105330',
    '&.Mui-checked': {
      color: '#2FB674'
    }
  },

  SubmitButton: {
    mt: 3,
    mb: 2,
    backgroundColor: '#105330',
    '&:hover': {
      backgroundColor: '#2FB674'
    },
    height: '48px',
    fontSize: '1rem',
    fontWeight: 'bold'
  },
  FooterContainer: styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '30px'
  }),

  ImageOverlay: styled('div')({
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    zIndex: 1
  }),

  RightPanel: styled('div')(({ theme }) => ({
    width: '500px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6),
    boxShadow: '-5px 0 15px rgba(0, 0, 0, 0.1)',
    [theme.breakpoints.down('lg')]: {
      width: '100%',
      padding: theme.spacing(4),
      boxShadow: 'none'
    }
  })),

  SuccessMessage: styled('div')(({ theme }) => ({
    backgroundColor: '#e8f5e9',
    color: '#2e7d32',
    padding: theme.spacing(2),
    borderRadius: '4px',
    marginBottom: theme.spacing(3),
    textAlign: 'center'
  })),

  Title: styled(Typography)(({ theme }) => ({
    color: '#105330',
    fontWeight: 'bold',
    marginBottom: theme.spacing(2),
    textAlign: 'center'
  })),

  Description: styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(4),
    textAlign: 'center'
  })),

  BackToLogin: styled('div')(({ theme }) => ({
    marginTop: theme.spacing(3),
    textAlign: 'center',
    '& a': {
      color: '#105330',
      fontWeight: '500',
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
        color: '#2FB674'
      }
    }
  }))
};
